export const Direction = Object.freeze({
    NONE: Symbol("none"),
    LEFT: Symbol("left"),
    RIGHT: Symbol("right"),
})

export const Motion = Object.freeze({
    IDLE: Symbol("Idle"),
    SITTING: Symbol("Sitting"),
	WALKING: Symbol("Walking"),
    RUNNING: Symbol("Running"),
	SLOWING: Symbol("Slowing"),
	TURNINGLEFT: Symbol("TurningLeft"),
	TURNINGRIGHT: Symbol("TurningRight")
})